import { Link } from "react-router-dom";

import { PrivateTick } from "components/buttons";
import { Image } from "components";
import { ReactComponent as BrokenImgIcon } from "components/icons/image_icon.svg";

import "./RawCollectionTile.scss";

export const RawCollectionTile = (props: {
  link: string;
  thumbnail: string | React.ReactElement;
  published: boolean;
  label: string;
}): JSX.Element => {
  return (
    <div className="tile">
      <Link to={props.link}>
        {typeof props.thumbnail === "string" ? (
          <>
            {props.thumbnail ? (
              <Image className="thumbnail" src={props.thumbnail} />
            ) : (
              <span>
                <BrokenImgIcon />
              </span>
            )}
          </>
        ) : (
          <span>{props.thumbnail}</span>
        )}

        {!props.published && <PrivateTick />}
      </Link>

      <div className="title" title={props.label}>
        {props.label}
      </div>
    </div>
  );
};
